export default "__VITE_ASSET__0bc95ef9__"